<template>
  <div class="step">
    <div class="step-wrapper">
      <h2>Диагноз</h2>
      <p class="description">Выберите верный ответ</p>
      <div class="items">
        <div v-for="item in items" class="item" :key="item.title" :class="itemClass(item)">
          <div class="item-title" @click="checkItem(item)">
            <img :src="checkboxState(item)" />
            {{ item.title }}<template v-if="item.opened">:</template>
          </div>
        </div>
      </div>
      <div v-if="!answered" class="step-button" @click="answered = true"><span>Ответить</span></div>
    </div>
    <div class="step-next" @click="$emit('step', 'treatment')">
      <span>Лечение</span>
      <svg viewBox="0 0 27 12" width="27" height="12">
        <path fill="#FFF" fill-rule="evenodd" d="M.01 5h17.14C15.83 3.07 15.17 1.8 15.1.09c3.01 2.96 6.93 4.5 11.67 5.95C22.03 7.43 18.29 9.12 15.1 12c.2-1.86.75-2.99 2.1-5.04H0V5z"/>
      </svg>
    </div>
    <div class="step-help">
      <div class="video-opener" @click="$emit('video', 'help-3')">
        <span>
          <img src="@/assets/help.png">
          Видео-подсказка
        </span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      answered: false,
      selected: null,
      items: [
        {
          name: 'q-1',
          title: 'Левосторонний вестибулярный нейронит',
          correct: true
        },
        {
          name: 'q-2',
          title: 'Болезнь Меньера',
          correct: false
        },
        {
          name: 'q-3',
          title: 'ДППГ',
          correct: false
        },
        {
          name: 'q-4',
          title: 'Псевдонейронит',
          correct: false
        },
        {
          name: 'q-5',
          title: 'Вестибулярная мигрень',
          correct: false
        }
      ]
    }
  },
  methods: {
    checkItem (item) {
      if (!this.answered) {
        this.selected = item.name
      }
    },
    itemClass (item) {
      return {
        'item--error': !item.correct && this.answered,
        'item--correct': item.correct && this.answered
      }
    },
    checkboxState (item) {
      const state = item.name === this.selected ? (!this.answered || item.correct ? 'radio-on' : 'radio-error') : 'radio-off'
      return require('@/assets/' + state + '.png')
    }
  }
}
</script>

<style lang="scss" scoped>
.description {
  font-size: 16px;
  color: #252628;
  margin: 0;
  padding: 0;
  font-style: italic;
}
.items {
  padding: 0 160px 0 0;
  margin: 0 0 32px;

  @include media-down(md) {
    padding: 0;
    margin: 0;
  }
}
.item {
  margin: 20px 0 20px 20px;
  line-height: 1.1;

  &-title {
    color: #252628;
    font-weight: bold;
    font-size: 18px;
    cursor: pointer;
    position: relative;

    @include media-down(lg) {
      font-size: 16px;
    }

    img {
      position: absolute;
      left: -20px;
      top: .15em;
    }
  }

  &--correct &-title {
    color: #009cde;
  }
  &--error &-title {
    color: #cd0000;
  }

  &-description {
    font-size: 16px;
    color: #252628;
    margin: 5px 0 0;

    @include media-down(lg) {
      font-size: 14px;
    }
  }
}
</style>
